<div class="content-wrapper-inner">
  <div class="page-content">
    <div class="d-flex justify-content-start align-items-center me-10 mb-20 w-25">
      <input type="search" class="form-control table-search ps-35" placeholder="Enter your search term" [formControl]="searchFormControl" />
      <span class="position-absolute icon-search ps-10"></span>
    </div>
    <div class="pos-relative">
      <app-phone-reports-table (changeBatch)="selectedRows = $event"></app-phone-reports-table>
      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" tabindex="0" (keyup.enter)="batchClear()" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{ selectedRows.length }} Selected</span>
          </div>
        </div>

        <button
          class="btn delete-report-btn info-right"
          [disabled]="!isAdmin()"
          (click)="batchDelete()"
          [tooltip]="tooltipText()"
          [options]="{ offset: [0, 12] }"
          [tooltipPlacement]="'right'">
          <i class="fas fa-trash text-icon-holder"></i>
          <span class="text">Delete</span>
        </button>
      </div>
    </div>
  </div>
</div>
